/**
 * PDP benefits carousel — prev/next scroll + mobile dot pagination.
 * Ported from PDPBenefits.tsx. Vanilla JS, no deps.
 */
(function () {
  function initBenefits(section) {
    var track = section.querySelector('[data-mel-benefits-track]');
    var prevBtn = section.querySelector('[data-mel-benefits-prev]');
    var nextBtn = section.querySelector('[data-mel-benefits-next]');
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-mel-benefits-dot]'));
    if (!track) return;

    function updateNav() {
      // When every card already fits in view (e.g. 3 cards at the 2xl
      // 3-up breakpoint), the track doesn't overflow: drop the edge-to-
      // edge bleed margin and center the row instead of leaving it
      // stretched past the container (matches PDPBenefits.tsx behavior).
      var overflows = track.scrollWidth > track.clientWidth + 1;
      track.style.marginRight = overflows ? 'calc(50% - 50vw)' : '0px';
      track.classList.toggle('justify-center', !overflows);

      var canScrollLeft = track.scrollLeft > 0;
      var canScrollRight = overflows && track.scrollLeft < track.scrollWidth - track.clientWidth - 1;
      if (prevBtn) prevBtn.disabled = !canScrollLeft;
      if (nextBtn) nextBtn.disabled = !canScrollRight;
      var navWrap = section.querySelector('[data-mel-benefits-nav]');
      if (navWrap) navWrap.classList.toggle('hidden', !canScrollLeft && !canScrollRight);
      var dotsWrap = section.querySelector('[data-mel-benefits-dots]');
      if (dotsWrap) dotsWrap.classList.toggle('hidden', !canScrollLeft && !canScrollRight);
    }

    function scroll(direction) {
      var isMobile = window.innerWidth < 768;
      var amount = isMobile ? 330 : track.clientWidth / 2 + 8;
      track.scrollBy({ left: direction === 'left' ? -amount : amount, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scroll('left'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scroll('right'); });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: (track.clientWidth - 32) * index, behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', updateNav);
    window.addEventListener('resize', updateNav);
    updateNav();
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-mel-benefits-track]')).forEach(function (track) {
      initBenefits(track.closest('section'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
